import { render, staticRenderFns } from "./DropdownMenuIcon.vue?vue&type=template&id=ee19fe3e&scoped=true"
import script from "./DropdownMenuIcon.vue?vue&type=script&lang=js"
export * from "./DropdownMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19fe3e",
  null
  
)

export default component.exports